import axiosInstance from "@/api/axios-instance";
import { GroupedBundlesResponse } from "@/pages/bundles/types/grouped-bundle";

export async function getBundlesGrouped({
  region,
  q,
}: {
  region?: string;
  q?: string;
}) {
  const params: Record<string, any> = {};
  if (region) params.region = region;
  if (q) params.q = q;

  const response = await axiosInstance.get("/bundle/grouped", { params });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("grouped bundles are not loaded");
  }

  return response.data as GroupedBundlesResponse;
}
